const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

/**
 * Format a file size in bytes to a human-readable string, e.g. `1,2 MB`.
 * Pass the app locale (from `useIntl`) for the correct decimal separator;
 * falls back to the runtime default when omitted.
 */
export const formatFileSize = (bytes: number, locale?: Intl.LocalesArgument): string => {
  if (bytes <= 0) return `0 ${FILE_SIZE_UNITS[0]}`;

  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), FILE_SIZE_UNITS.length - 1);
  const value = bytes / 1024 ** exponent;
  const formatted = value.toLocaleString(locale, { maximumFractionDigits: exponent === 0 ? 0 : 1 });

  return `${formatted} ${FILE_SIZE_UNITS[exponent]}`;
};
